import { Box, Tab, Tabs, useMediaQuery } from "@mui/material";
import PublicIcon from "@mui/icons-material/Public";
import SchoolIcon from "@mui/icons-material/School";
import { MOBILE_BREAKPOINT, STUDENT_CATEGORIES } from "utils/constants";

const StudentCategoryTabs = ({ value, onChange }) => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);

  return (
    <Box sx={{ mb: 2, borderBottom: 1, borderColor: "divider" }}>
      <Tabs
        value={value}
        onChange={(_, nextValue) => onChange(nextValue)}
        variant={isMobile ? "scrollable" : "standard"}
        scrollButtons="auto"
      >
        <Tab
          value={STUDENT_CATEGORIES.INTERNAL}
          icon={<SchoolIcon />}
          iconPosition="start"
          label="Студенти на университета"
        />
        <Tab
          value={STUDENT_CATEGORIES.EXTERNAL}
          icon={<PublicIcon />}
          iconPosition="start"
          label="Външни лица"
        />
      </Tabs>
    </Box>
  );
};

export default StudentCategoryTabs;
